import { Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Typography } from "@mui/material";
import React from "react";

const tableHeaderCellStyle = {
  textAlign: "center",
  fontWeight: 400,
  verticalAlign: "middle",
  color: "white",
  padding: "5px 5px",
  borderRight: "1px solid white",
};
const tableBodyCellStyle = {
  textAlign: "center",
  fontWeight: 400,
  verticalAlign: "middle",
  padding: "5px 5px",
  width: "100%",
  borderRight: "1px solid #7352C7",
};

const ListingInvoiceItems = ({ invoiceItems = [], totalAmount, totalExpenseAmount }) => {
  return (
    <TableContainer component={Paper} sx={{ mt: 2 }}>
      <Table size="small">
        <TableHead>
          <TableRow
            sx={{
              bgcolor: "#7352C7",
              color: "white",
            }}
          >
            <TableCell sx={{ ...tableHeaderCellStyle, minWidth: "60px" }}>Sr No.</TableCell>
            <TableCell sx={{ ...tableHeaderCellStyle, minWidth: "150px" }}>Supplier Item Name</TableCell>
            <TableCell sx={{ ...tableHeaderCellStyle, minWidth: "150px" }}>Supplier Code</TableCell>
            <TableCell sx={{ ...tableHeaderCellStyle, minWidth: "150px" }}>Item Name</TableCell>
            <TableCell sx={{ ...tableHeaderCellStyle, minWidth: "150px" }}>Item Sub Category</TableCell>
            <TableCell sx={{ ...tableHeaderCellStyle, minWidth: "150px" }}>Log Code</TableCell>
            <TableCell sx={{ ...tableHeaderCellStyle, minWidth: "150px" }}>Cut Name</TableCell>
            <TableCell sx={{ ...tableHeaderCellStyle, minWidth: "150px" }}>Series Name</TableCell>
            <TableCell sx={{ ...tableHeaderCellStyle, minWidth: "150px" }}>Grade Name</TableCell>
            <TableCell sx={{ ...tableHeaderCellStyle, minWidth: "150px" }}>Bundle Number</TableCell>
            <TableCell sx={{ ...tableHeaderCellStyle, minWidth: "150px" }}>Pallet Number</TableCell>
            <TableCell sx={{ ...tableHeaderCellStyle, minWidth: "150px" }}>Length</TableCell>
            <TableCell sx={{ ...tableHeaderCellStyle, minWidth: "150px" }}>Width</TableCell>
            <TableCell sx={{ ...tableHeaderCellStyle, minWidth: "150px" }}>Thickness</TableCell>
            <TableCell sx={{ ...tableHeaderCellStyle, minWidth: "150px" }}>Number of Leaves</TableCell>
            <TableCell sx={{ ...tableHeaderCellStyle, minWidth: "150px" }}>Total Sq.m.</TableCell>
            <TableCell sx={{ ...tableHeaderCellStyle, minWidth: "150px" }}>Amount</TableCell>
            <TableCell sx={{ ...tableHeaderCellStyle, minWidth: "150px" }}>Expense Amount</TableCell>
            <TableCell sx={{ ...tableHeaderCellStyle, minWidth: "150px" }}>Remark</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {invoiceItems &&
            invoiceItems?.map((row, i) => (
              <TableRow key={i}>
                <TableCell sx={{ ...tableBodyCellStyle }}>{row?.item_sr_no}</TableCell>
                <TableCell sx={{ ...tableBodyCellStyle }}>{row?.supplier_item_name}</TableCell>
                <TableCell sx={{ ...tableBodyCellStyle }}>{row?.supplier_code}</TableCell>
                <TableCell sx={{ ...tableBodyCellStyle }}>{row?.item_name}</TableCell>
                <TableCell sx={{ ...tableBodyCellStyle }}>{row?.item_sub_category_name}</TableCell>
                <TableCell sx={{ ...tableBodyCellStyle }}>{row?.cut_name}</TableCell>
                <TableCell sx={{ ...tableBodyCellStyle }}>{row?.series_name}</TableCell>
                <TableCell sx={{ ...tableBodyCellStyle }}>{row?.grades_name}</TableCell>
                <TableCell sx={{ ...tableBodyCellStyle }}>{row?.log_code}</TableCell>
                <TableCell sx={{ ...tableBodyCellStyle }}>{row?.bundle_number}</TableCell>
                <TableCell sx={{ ...tableBodyCellStyle }}>{row?.pallet_number}</TableCell>
                <TableCell sx={{ ...tableBodyCellStyle }}>{row?.length}</TableCell>
                <TableCell sx={{ ...tableBodyCellStyle }}>{row?.width}</TableCell>
                <TableCell sx={{ ...tableBodyCellStyle }}>{row?.thickness}</TableCell>
                <TableCell sx={{ ...tableBodyCellStyle }}>{row?.number_of_leaves}</TableCell>
                <TableCell sx={{ ...tableBodyCellStyle }}>{row?.total_sq_meter}</TableCell>
                <TableCell sx={{ ...tableBodyCellStyle }}>{row?.amount}</TableCell>
                <TableCell sx={{ ...tableBodyCellStyle }}>{row?.expense_amount}</TableCell>
                <TableCell sx={{ ...tableBodyCellStyle }}>{row?.remark}</TableCell>
              </TableRow>
            ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TableCell colSpan={15} align="center"></TableCell>
            <TableCell align="center">
              <Typography fontSize="14px" color="black" m={0}>
                Total:
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography fontSize="14px" color="black" m={0}>
                {totalAmount}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography fontSize="14px" color="black" m={0}>
                {totalExpenseAmount}
              </Typography>
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default ListingInvoiceItems;
